export { default as CmsHeroSwitch } from './CmsHeroSwitch';
